module.exports = __webpack_public_path__ + "img/cafe.b808e3b2.png";